import React from 'react'
import PropTypes from 'prop-types'
import { TransitionState } from 'gatsby-plugin-transition-link'
import { motion, AnimatePresence } from 'framer-motion'

const PageTransition = ({ children }) => {
  const variants = {
    hidden: { 
      opacity: 0,
    },
    visible: { 
      opacity: 1,
      x: 0
    },
  }

  return (
    <TransitionState>
      {() => {
        return (
          <AnimatePresence>
            <motion.div initial="hidden" animate="visible" variants={variants} exit={{ opacity: 0 }}>
              {children}
            </motion.div>
          </AnimatePresence>
        )
      }}
    </TransitionState>
  )
}

PageTransition.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PageTransition
